/*###########################################################################
// Components
//#########################################################################*/

/* Dynamic Components
//------------------*/

if (document.querySelector('.accordion')) {
  import('./_accordions')
}

if (document.querySelector('.copy-clipboard')) {
	import('./_copyClipboard')
}

if (document.querySelector('.modal')) {
	import('./_modals')
}

if (document.querySelector('.responsive-video')) {
	import('./_responsiveVideo')
}

if (document.querySelector('.sprigFilter')) {
	import('./_sprigFilter')
}

if (document.querySelector('[data-path-marquee]')) {
	import('./_pathMarquee')
}

if (document.querySelector('[data-intro-scroll]')) {
	import('./_railScroll')
}

/* Standard Components
//------------------*/

import './_browserDetect'
import './_forms'
import './_header'
import './_reveal'
